<template>
  <div class="mt-2">
    <div class="operation-item">
      <span class="operation-text">Operation {{ index + 1 }}</span>
      <div class="line"></div>
      <el-button class="remove-operation-button" type="danger" size="mini" @click="$emit('remove', index)"
        v-if="!formDisabled">
        {{ $t("btn.remove") }}
      </el-button>
      <el-button size="mini" v-if="showModifyButton && operation.requestStatus !== 1" type="primary"
        @click="handleRequestClick">
        {{ $t("btn.rforModification") }}
      </el-button>

      <el-button size="mini" v-if="showModifyButton && operation.requestStatus === 1" class="textBtn" type="text"
        @click="handleRequestClick">
        {{ $t("btn.rdForModification") }}
      </el-button>
    </div>

    <el-form :ref="'elOperationForm' + index" :model="operation" :rules="rules" size="small"
      :label-width="isMobileScreen ? null : '200px'" label-position="left" :disabled="formDisabled">

      <el-form-item :label="'ID :'" prop="id">
        <el-input :disabled="true || !isCustomerAdmin" v-model="operation.id">
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('table.operation') + ':'" prop="operationType" :disabled="formDisabled">
        <el-select size="small" v-model="operation.operationType" :style="{ width: '100%' }"
          @change="handleOperationChange">
          <el-option v-for="[value, label] in Object.entries(OperationType)" :key="value" :label="label"
            :value="value" />
        </el-select>
      </el-form-item>

      <el-form-item label="Nominated Qty:" prop="nominatedQty">
        <div class="flex justify-between" :class="{ 'flex-col': isMobileScreen }">
          <div class="flex w-full">
            <el-input v-model.number="operation.nominatedQty" type="number">
              <el-select slot="append" v-model="operation.nominatedQtyUnit"
                style="width: 90px; padding-block: 9px; padding-right: 9px; padding-top: 10px;"
                popper-class="qty-unit-popper">
                <el-option label="MT" value="MT" />
                <el-option label="BBL" value="BBL" />
              </el-select>
            </el-input>
          </div>
          <el-form :ref="'elOperationForm' + index" :model="operation" :rules="rules" size="small"
            :label-width="isMobileScreen ? null : '200px'" label-position="left">
            <div class="flex" v-if="allowToChangeQuantity" :class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain @click="openChangeQuantityDialog" style="width: 130px;">
                Change Quantity
              </el-button>
            </div>
          </el-form>
        </div>
        <div v-if="operation.qtyRequestStatus" style="color:#FF5C00; font-size:11px">
          Requested to change quantity to {{ operation.newNominatedQtyMax }} MT
        </div>
      </el-form-item>

      <el-form-item :label="$t('table.tanks') + ':'" prop="tlist" v-if="!formDisabled">
        <div class="flex justify-between" v-bind:class="{ 'flex-col': isMobileScreen }">
          <div class="flex w-full">
            <el-select multiple v-model="operation.tlist" placeholder="" clearable size="small"
              :style="{ width: '100%' }">
              <el-option v-for="(item) in tankOptions" :key="item.label" :label="item.label" :value="item.value"
                :disabled="item.disabled"></el-option>
            </el-select>
          </div>
          <el-form :ref="'elOperationForm' + index" :model="operation" :rules="rules" size="small"
            :label-width="isMobileScreen ? null : '200px'" label-position="left">
            <div class="flex" v-if="allowToChangeTank"
              v-bind:class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain :disabled="false" @click="openChangeTankDialog"
                style="width: 130px;">Change
                Tank(s)</el-button>
            </div>
          </el-form>
        </div>
        <div v-if="operation.tankRequestStatus" style="color:#FF5C00; font-size:11px"> Requested to change tank(s) to {{
          operation.newTank }} </div>
      </el-form-item>
      <el-form-item :label="$t('table.tanks') + ':'" prop="tankDetails" v-if="formDisabled">
        <div class="flex justify-between" :class="{ 'flex-col': isMobileScreen }">
          <div class="flex w-full">
            <el-select multiple v-model="selectedTankIds" placeholder="" clearable size="small"
              :style="{ width: '100%' }" disabled>
              <el-option v-for="item in operation.tankDetails" :key="item.id" :label="item.tankName" :value="item.id" />
            </el-select>
          </div>

          <el-form :ref="'elOperationForm' + index" :model="operation" :rules="rules" size="small"
            :label-width="isMobileScreen ? null : '200px'" label-position="left">
            <div v-if="allowToChangeTank" :class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain @click="openChangeTankDialog" style="width: 130px;">
                Change Tank(s)
              </el-button>
            </div>
          </el-form>
        </div>

        <div v-if="operation.tankRequestStatus" style="color:#FF5C00; font-size:11px">
          Requested to change tank(s) to {{ operation.newTank }}
        </div>
      </el-form-item>

      <el-form-item :label="$t('table.product') + ':'" prop="product" :disabled="formDisabled">
        <div class="flex justify-between" v-bind:class="{ 'flex-col': isMobileScreen }">
          <div class="flex w-full">
            <el-select size="small" v-model="operation.product" placeholder="" clearable :style="{ width: '100%' }">
              <el-option v-for="(item, index) in productOptions" :key="index" :label="item.label" :value="item.value"
                :disabled="item.disabled"></el-option>
            </el-select>
          </div>
          <el-form :ref="'elOperationForm' + index" :model="operation" :rules="rules" size="small"
            :label-width="isMobileScreen ? null : '200px'" label-position="left">
            <div class="flex" v-if="allowToChangeProduct"
              v-bind:class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain :disabled="false" @click="openChangeProductDialog"
                style="width: 130px;">Change
                Product</el-button>
            </div>
          </el-form>
        </div>
        <div v-if="operation.productRequestStatus" style="color:#FF5C00; font-size:11px"> Requested to change product to
          {{
            operation.newProduct }} </div>
      </el-form-item>

      <el-form-item v-if="!isDischargeOperation" :label="$t('table.doc') + ':'" prop="doc" :disabled="formDisabled">
        <el-select size="small" v-model="operation.doc" placeholder="" clearable :style="{ width: '100%' }">
          <el-option v-for="(item, index) in docOptions" :key="index" :label="item.label" :value="item.value"
            :disabled="item.disabled"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('table.remarks') + ':'" prop="remarks" :disabled="formDisabled">
        <el-input size="small" v-model="operation.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }"
          :style="{ width: '100%' }"></el-input>
      </el-form-item>

      <el-form-item v-if="isDischargeOperation"
        :label="'Attachment: (E.g. Manifest, Receipt of Samples, Certificate of Origin etc.)'" :label-width="'120px'"
        style="margin-top: 24px;" :disabled="formDisabled">
        <el-button type="primary" plain style="margin-left: 80px; background-color: white; margin-bottom: 20px;"
          size="mini" @click="showAttachmentDialog = true" v-if="!formDisabled">
          Upload PDF
        </el-button>

        <!-- Display existing files -->
        <div v-if="operation.attachments && operation.attachments.length > 0" style="margin-left: 80px;">
          <div v-for="(attachment, index) in operation.attachments" :key="'attachment-' + index"
            style="display: flex; align-items: center; margin-bottom: 5px; background-color: #f9f9f9; padding: 8px; border-radius: 4px;"
            @click="viewFile(attachment)">
            <h1 style="flex-grow: 1; font-size: 12px;">
              {{ attachment.name }}
            </h1>
            <el-button type="text" icon="el-icon-close" size="mini" style="color: #f56c6c;"
              @click.stop="removeAttachment(index)"></el-button>
          </div>
        </div>

        <div v-if="operation.attachments && operation.attachments.length == 0"
          style="margin-top: 10px; margin-left: 80px;">
          No Attachment</div>
      </el-form-item>

    </el-form>

    <el-dialog :title="'Upload Attachment for Operation ' + (index + 1)" :visible.sync="showAttachmentDialog"
      width="500px" :close-on-click-modal="false">
      <div class="drag-drop-area" @dragover.prevent="handleDragOver" @drop="handleDrop"
        style="border: 2px dashed #ccc; padding: 20px; text-align: center; cursor: pointer;">
        <p>Drag and drop your PDF file here</p>
        <p>or</p>
        <el-button size="small" type="primary" @click="triggerAttachmentFileUpload">Select File</el-button>
        <input type="file" :id="'attachment-upload-dialog-' + index" accept=".pdf" multiple style="display: none;"
          @change="handleAttachmentSelect" />
      </div>
    </el-dialog>

    <pdf-view title="Attachment" :pdfUrl="pdfUrl" v-model="showPdfView" />
  </div>
</template>

<script>
import { OperationType } from '@/utils/constants';
import PdfView from "@/components/common/pdf-view.vue"

const DISCHARGE_OPERATION_VALUE = 1;

export default {
  name: "OperationForm",
  components: { PdfView },
  props: {
    index: {
      type: Number,
      required: true,
    },
    operation: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        operationType: null,
        nominatedQty: '',
        qtyType: null,
        qtyRequestStatus: false,
        newNominatedQtyMax: '',
        tlist: [],
        tankRequestStatus: false,
        newTank: '',
        product: null,
        productRequestStatus: false,
        newProduct: '',
        doc: null,
        remarks: '',
        attachments: [],
        deleteFileIds: [],
        tankDetails: [],
        nominatedQtyUnit: 'MT',
      }),
    },
    showRemove: {
      type: Boolean,
      default: true,
    },
    isMobileScreen: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
      default: () => ({}),
    },
    formDisabled: {
      type: Boolean,
      default: false,
    },
    allowToChangeQuantity: {
      type: Function
    },
    NomQty: {
      type: Object,
      default: () => ({}),
    },
    tankOptions: {
      type: Array,
    },
    isCustomerAdmin: {
      type: Boolean,
      default: false,
    },
    allowToChangeTank: {
      type: Function
    },
    productOptions: {
      type: Array,
    },
    allowToChangeProduct: {
      type: Function
    },
    docOptions: {
      type: Array,
      default: () => [],
    },
    OperationType: {
      type: Object,
    },
    allowToModifyOperation: {
      type: Function
    },
    showModifyButton: {
      type: Function
    }
  },
  data() {
    return {
      showAttachmentDialog: false,
      dragActive: false,
      selectedAttachment: null,
      deleteFileIds: "",
      showPdfView: false,
      pdfUrl: "",
    };
  },
  computed: {
    isDischargeOperation() {
      return this.operation.operationType === "1" || this.operation.operationType === "Discharge" || this.operation.operationType === DISCHARGE_OPERATION_VALUE;
    },
    selectedTankIds() {
      return this.operation.tankDetails.map(tank => tank.id);
    },
  },
  mounted() {
  },
  methods: {
    sanitizeQtyInput(val) {
      const stringVal = String(val || '');
      const sanitized = stringVal.replace(/[^\d.]/g, "").replace(/^0+/, "0");
      this.$set(this.operation, "nominatedQtyMax", sanitized);
    },
    openChangeQuantityDialog() {
      this.$emit("open-change-qty", this.index);
    },
    openChangeTankDialog() {
      this.$emit("open-change-tank", this.index);
    },
    openChangeProductDialog() {
      this.$emit("open-change-product", this.index);
    },
    handleRequestClick() {
      this.$emit("request-modification", this.index);
    },
    triggerAttachmentFileUpload() {
      document.getElementById(`attachment-upload-dialog-${this.index}`).click();
    },
    handleAttachmentSelect(event) {
      const files = Array.from(event.target.files);
      files.forEach(file => {
        this.handleFile(file);
      });
    },
    handleDragOver(event) {
      this.dragActive = true;
    },
    handleDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      this.dragActive = false;
      const files = Array.from(event.dataTransfer.files).filter(f => f.type === 'application/pdf');
      files.forEach(file => {
        this.handleFile(file);
      });
    },
    handleFile(file) {
      if (file && file.type === 'application/pdf') {
        const isDuplicate = this.operation.attachments.some(
          attachment => attachment.name === file.name
        );

        if (!isDuplicate) {
          this.operation.attachments.push({
            name: file.name,
            raw: file,
            documentUrl: URL.createObjectURL(file),
            createTime: new Date().toLocaleString(),
          });
        } else {
          this.$message.warning(`The file "${file.name}" is already uploaded.`);
        }
      } else if (file) {
        this.$message.warning('Please upload a valid PDF file.');
      }
    },
    removeAttachment(indexToRemove) {
      const removedFile = this.operation.attachments[indexToRemove];

      if (removedFile?.documentUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(removedFile.documentUrl);
      }

      if (removedFile?.id) {
        if (this.operation.deleteFileIds) {
          this.operation.deleteFileIds += `,${removedFile.id}`;
        } else {
          this.operation.deleteFileIds = `${removedFile.id}`;
        }
      }

      this.operation.attachments.splice(indexToRemove, 1);
      this.$emit("update-delete-file-ids", {
        index: this.index,
        deleteFileIds: this.operation.deleteFileIds,
      });
    },
    handleOperationChange(val) {
      this.operation.deleteFileIds = [];
      if (this.operation.id) {
        if (val == 0) {
          this.operation.attachments.forEach((item, index) => {
            if (item.id) {
              if (index != 0) {
                this.operation.deleteFileIds += `,${item.id}`;
              } else {
                this.operation.deleteFileIds = `${item.id}`;
              }
            }
            this.operation.attachments.splice(item.id, 1);
            this.$emit('update-delete-file-ids', { index: this.index, deleteFileIds: this.operation.deleteFileIds });
          })
          this.operation.operationType = val;
        } else if (val == 1) {
          this.operation.doc = null;
        }

        this.operation.operationType = val
      }
    },
    viewFile(file) {
      if (file?.documentUrl?.startsWith("blob:")) {
        this.pdfUrl = file.documentUrl;
        this.showPdfView = true;
        return;
      }

      if (file?.documentUrl) {
        if (/^https?:\/\//i.test(file.documentUrl)) {
          this.pdfUrl = file.documentUrl;
        } else {
          this.pdfUrl = process.env.VUE_APP_BASE_API + file.documentUrl;
        }
        this.showPdfView = true;
        return;
      }

      this.$message.warning("Unable to view the file");
    }

  }
};
</script>

<style scoped>
.operation-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.operation-text {
  font-weight: bold;
}

.line {
  flex-grow: 1;
  height: 1px;
  background-color: #ddd;
}

:deep(.padded-input .el-input__inner) {
  padding-left: 30px;
}

.el-form-item {
  row-gap: 20px;
}

::v-deep .remove-operation-button:hover {
  background-color: white !important;
  /* Your custom color */
  border-color: red !important;
  color: red;
  opacity: 0.5;
}

::v-deep .remove-operation-button {
  background-color: white !important;
  /* Your custom color */
  border-color: red !important;
  color: red;
}
</style>